import {
  assign, endpoint, options, convert,
} from '../../helpers';
import { User } from '../../../tools';
import models from './models';

/**
 * It goes to "login" service with the given information
 * and performs the authentication process
 *
* @param {Object} props All parameters to be used in the function
* @param {Object=} props.data The data object to be used in the request to be sent
* @param {function=} props.dispatch Redux dispatcher
* @param {function=} props.error Failed callback function
* @param {function=} props.success Successful callback function
 */

const login = (props) => {
  const state = assign(props);
  const model = models.request(state.data);
  fetch(endpoint('/login'), options(model, false))
    .then(response => response.json())
    .then((response) => {
      if (response.Success) {
        const data = models.response({
          ...response.Data,
          Token: response.Token,
          aiApiKey: response.Data.AIApiKey1,
        });
        User.setUserInfo(data);
        state.success(data);
      } else {
        state.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default login;
